import React, { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import { StreamActions } from "@hotwired/turbo";

const toastColor = (type) => {
    if (type === "success") return "#059669";
    if (type === "warning") return "#D97706";
    return "#DC2626";
};

const Toast = ({ notice, alert, warning }) => {
    const handleToastEvent = (event) => {
        const { message, type = "success" } = event.detail;
        toast[type](message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
            style: {
                background: toastColor(type),
                color: "white",
            },
        });
    };

    StreamActions.show_toast = function () {
        const message = this.getAttribute("message");
        const type = this.getAttribute("toast_type") || "success";

        if (message) {
            handleToastEvent({ detail: { message, type } });
        }
    }

    useEffect(() => {
        if (notice) {
            handleToastEvent({ detail: { message: notice, type: "success" } });
        } else if (warning) {
            handleToastEvent({ detail: { message: warning, type: "warning" } });
        } else if (alert) {
            handleToastEvent({ detail: { message: alert, type: "error" } });
        }
    }, [notice, alert, warning]);

    useEffect(() => {
        document.addEventListener("show-toast", handleToastEvent);
        return () => document.removeEventListener("show-toast", handleToastEvent);
    }, []);

    return(
        <ToastContainer />
    )
};

export default Toast;